import Box from "@material-ui/core/esm/Box";
import React from 'react';
import AddressFormSection from 'components/AddressFormSection/AddressFormSection';
import Dialog from 'components/Dialog/Dialog';
export default function AddressDialog({
  open,
  onClose,
  onPrimaryBtnClick,
  primaryBtnClickIsDisabled,
  isLoading,
  primaryBtnTitle,
  dialogTitle,
  subtitle = undefined
}) {
  return /*#__PURE__*/React.createElement(Dialog, {
    open: open,
    onClose: onClose,
    isLoading: isLoading,
    dialogTitle: dialogTitle,
    primaryBtnClickIsDisabled: primaryBtnClickIsDisabled,
    onPrimaryBtnClick: onPrimaryBtnClick,
    primaryBtnTitle: primaryBtnTitle
  }, subtitle && /*#__PURE__*/React.createElement(Box, {
    my: 2
  }, subtitle), /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement(AddressFormSection, {
    isNewCustomer: false
  })));
}
AddressDialog.defaultProps = {
  subtitle: undefined
};